import { render, staticRenderFns } from "./CittadinoHome.vue?vue&type=template&id=4580e1e8&scoped=true&"
import script from "./CittadinoHome.vue?vue&type=script&lang=js&"
export * from "./CittadinoHome.vue?vue&type=script&lang=js&"
import style0 from "./CittadinoHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CittadinoHome.vue?vue&type=style&index=1&id=4580e1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580e1e8",
  null
  
)

export default component.exports